var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { pageWindow } from '../../../../domain';
/**
 * Uma opcao de escolha unica - a janela, o segmento, o porte ou a aba.
 *
 * `value` e o que o seletor usa como chave; a escolha marca `current` no lugar, sem
 * refazer a lista (ver `CompanyUserFormPresenter.showTypes`).
 */
let IcpOptionScope = class IcpOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpOptionScope.prototype, "current", void 0);
IcpOptionScope = __decorate([
    Observable
], IcpOptionScope);
export { IcpOptionScope };
/** Um numero do topo, com o texto pronto - o `MetricCard` da view. */
let IcpKpiScope = class IcpKpiScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '-';
        /** O icone, pelo nome - ver `icon-catalog.tsx` na view. */
        this.icon = '';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpKpiScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpKpiScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], IcpKpiScope.prototype, "hint", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], IcpKpiScope.prototype, "help", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpKpiScope.prototype, "icon", void 0);
IcpKpiScope = __decorate([
    Observable
], IcpKpiScope);
export { IcpKpiScope };
/** Uma dimensao em que as empresas Excelente se distinguem das demais. */
let IcpHighlightScope = class IcpHighlightScope extends Scope {
    constructor() {
        super(...arguments);
        this.dimension = '';
        this.value = '';
        /** `45,0% nas Excelente contra 20,0% nas demais (em empresas)`. */
        this.detail = '';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpHighlightScope.prototype, "dimension", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpHighlightScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpHighlightScope.prototype, "detail", void 0);
IcpHighlightScope = __decorate([
    Observable
], IcpHighlightScope);
export { IcpHighlightScope };
/** Uma coluna ordenavel do scorecard. */
let IcpColumnScope = class IcpColumnScope extends Scope {
    constructor() {
        super(...arguments);
        this.field = 'name';
        this.label = '';
        this.sorted = false;
        this.descending = false;
        /** A coluna se arrasta para outro lugar - todas, menos a da empresa, que identifica a linha. */
        this.movable = false;
        this.onSort = Scope.ASYNC_ACTION;
        /** Outra coluna, `source`, foi solta sobre esta. */
        this.onDrop = () => undefined;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], IcpColumnScope.prototype, "field", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpColumnScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpColumnScope.prototype, "sorted", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpColumnScope.prototype, "descending", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpColumnScope.prototype, "movable", void 0);
IcpColumnScope = __decorate([
    Observable
], IcpColumnScope);
export { IcpColumnScope };
/** Uma empresa no scorecard, com o texto de cada celula pronto. */
let IcpCompanyRowScope = class IcpCompanyRowScope extends Scope {
    constructor() {
        super(...arguments);
        this.companyId = 0;
        this.name = '';
        this.scoreLabel = '-';
        /** Score de amostra insuficiente: aparece apagado, porque nao sustenta comparacao. */
        this.scoreMuted = false;
        this.band = 'AMOSTRA_INSUFICIENTE';
        this.bandLabel = '';
        /** Vazio quando a empresa ainda nao foi classificada. */
        this.segmentLabel = '';
        this.sizeLabel = '';
        /** O porte saiu dos colaboradores CADASTRADOS: a empresa nao tem o numero contratado. */
        this.sizeEstimated = false;
        this.sizeHint = '';
        this.collaboratorsLabel = '';
        this.activationLabel = '-';
        this.engagementLabel = '-';
        this.retentionLabel = '-';
        this.trainingLabel = '-';
        /** Abre Colaboradores na empresa da linha. */
        this.onOpenCollaborators = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "companyId", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "scoreLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "scoreMuted", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], IcpCompanyRowScope.prototype, "band", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "bandLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "segmentLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "sizeLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "sizeEstimated", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "sizeHint", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "collaboratorsLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "activationLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "engagementLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "retentionLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpCompanyRowScope.prototype, "trainingLabel", void 0);
IcpCompanyRowScope = __decorate([
    Observable
], IcpCompanyRowScope);
export { IcpCompanyRowScope };
/** Um grupo da comparacao - um segmento ou um porte. */
let IcpGroupRowScope = class IcpGroupRowScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.companiesLabel = '';
        this.withScoreLabel = '';
        this.averageScoreLabel = '-';
        this.engagementLabel = '-';
        this.retentionLabel = '-';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpGroupRowScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpGroupRowScope.prototype, "companiesLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpGroupRowScope.prototype, "withScoreLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpGroupRowScope.prototype, "averageScoreLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpGroupRowScope.prototype, "engagementLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpGroupRowScope.prototype, "retentionLabel", void 0);
IcpGroupRowScope = __decorate([
    Observable
], IcpGroupRowScope);
export { IcpGroupRowScope };
/**
 * Um lado de uma linha da persona - as pessoas das empresas (B2B) ou as sem empresa.
 *
 * Tres estados, e a view desenha cada um: o valor nao existe daquele lado (`absent`), o
 * grupo e pequeno demais para mostrar (`suppressed`), ou os numeros.
 */
let IcpPersonaCellScope = class IcpPersonaCellScope extends Scope {
    constructor() {
        super(...arguments);
        this.absent = false;
        this.suppressed = false;
        this.peopleLabel = '';
        this.shareLabel = '';
        this.engagementLabel = '';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaCellScope.prototype, "absent", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaCellScope.prototype, "suppressed", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaCellScope.prototype, "peopleLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaCellScope.prototype, "shareLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaCellScope.prototype, "engagementLabel", void 0);
IcpPersonaCellScope = __decorate([
    Observable
], IcpPersonaCellScope);
export { IcpPersonaCellScope };
/** Um valor de uma dimensao da persona - uma faixa de idade, um sexo. */
let IcpPersonaRowScope = class IcpPersonaRowScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.b2b = new IcpPersonaCellScope();
        this.b2c = new IcpPersonaCellScope();
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaRowScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaRowScope.prototype, "b2b", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaRowScope.prototype, "b2c", void 0);
IcpPersonaRowScope = __decorate([
    Observable
], IcpPersonaRowScope);
export { IcpPersonaRowScope };
/** Uma dimensao da persona: uma tabela. */
let IcpPersonaTableScope = class IcpPersonaTableScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.rows = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpPersonaTableScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpPersonaTableScope.prototype, "rows", void 0);
IcpPersonaTableScope = __decorate([
    Observable
], IcpPersonaTableScope);
export { IcpPersonaTableScope };
let IcpScope = class IcpScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        // :: filtros
        this.windows = [];
        this.segments = [];
        this.segmentSummary = '';
        this.sizes = [];
        this.sizeSummary = '';
        // :: abas
        this.tab = 'companies';
        this.tabs = [];
        // :: empresas
        this.hasOverview = false;
        this.kpis = [];
        /** `2 empresas Excelente comparadas com 5 outras com score`. */
        this.idealSummary = '';
        this.highlights = [];
        /** Poucas empresas com score: o perfil e uma pista, nao uma conclusao. */
        this.smallSample = false;
        this.hasScorecard = false;
        this.scorecardDescription = '';
        this.columns = [];
        this.rows = [];
        this.page = 1;
        /** 25 por pagina, como o painel antigo: o scorecard cabe numa tela sem rolar demais. */
        this.perPage = 25;
        this.total = 0;
        /** Quantas empresas ainda nao tem segmento - e o atalho para classifica-las. */
        this.unsegmentedCount = 0;
        this.onlyUnsegmented = false;
        this.bySegment = [];
        this.bySize = [];
        /** `Como o score é calculado (dados até 14/10/2026)`. */
        this.methodologyTitle = '';
        this.methodology = [];
        // :: persona
        this.personaLoading = false;
        this.personaDescription = '';
        this.personaFootnote = '';
        this.personaTables = [];
        this.onClearSegment = Scope.ASYNC_ACTION;
        this.onClearSize = Scope.ASYNC_ACTION;
        /** O "Atualizar" do topo: refaz as consultas sem mudar filtro algum. */
        this.onRefresh = Scope.ASYNC_ACTION;
        this.onToggleUnsegmented = Scope.ASYNC_ACTION;
        this.onExportScorecard = Scope.ASYNC_ACTION;
        this.onPreviousPage = Scope.ASYNC_ACTION;
        this.onNextPage = Scope.ASYNC_ACTION;
        this.onGoToPage = Scope.ASYNC_ACTION_NUMBER;
    }
    get pageCount() {
        return Math.max(1, Math.ceil(this.total / Math.max(1, this.perPage)));
    }
    /** As paginas que o paginador oferece - ver `CompaniesScope.pageWindow`. */
    get pageWindow() {
        return pageWindow(this.page, this.pageCount);
    }
};
__decorate([
    observe(),
    __metadata("design:type", Function)
], IcpScope.prototype, "layout", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], IcpScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "windows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "segments", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "segmentSummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "sizes", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "sizeSummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], IcpScope.prototype, "tab", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "tabs", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "hasOverview", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "kpis", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "idealSummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], IcpScope.prototype, "idealEmpty", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "highlights", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "smallSample", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "hasScorecard", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "scorecardDescription", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "columns", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "rows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "page", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "perPage", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "total", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "unsegmentedCount", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "onlyUnsegmented", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "bySegment", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "bySize", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "methodologyTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "methodology", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "personaLoading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "personaDescription", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], IcpScope.prototype, "personaFootnote", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], IcpScope.prototype, "personaTables", void 0);
IcpScope = __decorate([
    Observable
], IcpScope);
export { IcpScope };
//# sourceMappingURL=icp.scope.js.map